import { createAction, props } from '@ngrx/store';

import { ListOfValuesResponse } from '#types/list';

//
// lists
//

export const initialize = createAction('[Lists] - Initialize');

//
// static lists
//

export const setStaticLists = createAction('[Lists] - Set Static Lists', props<{ yesNo: ListOfValuesResponse }>());
